import { defaultRangePreset } from '@gogame/intl-ts';

export const useFiltersWithPeriodType = (filters) => {
  const { expirationPeriodType, createdPeriodType, ...newFilters } = filters;

  defaultRangePreset.forEach(({ key, value }) => {
    let expirationPeriodEqual = 0;
    let createdPeriodEqual = 0;
    value.forEach((val, index) => {
      if (val === newFilters.expirationPeriod[index]) {
        expirationPeriodEqual++;
      }
      if (expirationPeriodEqual === value.length) {
        newFilters.expirationPeriodType = key[0];
      }
      if (val === newFilters.create[index]) {
        createdPeriodEqual++;
      }
      if (createdPeriodEqual === value.length) {
        newFilters.createdPeriodType = key[0];
      }
    });
  });

  return newFilters;
};
